module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Ошибка":"Error","Страница не найдена. Проверьте правильность введенного адреса.":"Page not found. Check the address you entered."}}')
  delete Component.options._Ctor
}
